import { Factory, trait } from 'miragejs';
import { faker } from '@faker-js/faker';

export default Factory.extend({
  callStatus() {
    return faker.helpers.weightedArrayElement([
      { value: 'in-progress', weight: 5 },
      { value: 'completed', weight: 80 },
      { value: 'missed', weight: 15 },
      //  { value: 'disconnected', weight: number },  // HOLD OFF
    ]);
  },

  deviceName() {
    const num = faker.location.buildingNumber();
    const dir = faker.location.cardinalDirection();

    return `${num} ${dir}`;
  },

  durationSeconds() {
    switch (this.callStatus) {
      case 'in-progress':
        return null;
      case 'missed':
        return faker.number.int({ min: 10, max: 60 });
      default:
        return faker.number.int({ min: 40, max: 1200 });
    }
  },

  timeToAnswerSeconds() {
    switch (this.callStatus) {
      case 'in-progress':
        return null;
      case 'missed':
        return null;
      default:
        return faker.number.int({ min: 10, max: 60 });
    }
  },

  startedAt() {
    const ms = faker.number.int({ min: 40000, max: 1200000 });

    switch (this.callStatus) {
      case 'in-progress':
        return new Date(Date.now() - ms).toJSON();
      default:
        return faker.date.recent({ days: 10 }).toJSON();
    }
  },

  withTranscription: trait({
    afterCreate(vfdCallLog, server) {
      const status = vfdCallLog.callStatus === 'completed' ? 'available' : 'unavailable';

      server.create('vfd-call-log-transcription', { status, vfdCallLog } );
    },
  }),
});
